import { apiBaseUrl, getTrpcOwner } from "../../main/components/trpc.ts";

export function getPecPdfUrl(documentId: string) {
  const params = new URLSearchParams({ id: documentId });
  const owner = getTrpcOwner();
  if (owner) {
    params.set("owner", owner);
  }

  return `${apiBaseUrl}/cadendarRest/pec/document/file?${params.toString()}`;
}
